(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

/* am-one-open:start */
/* Variante Casavono : sur les fiches desktop la page défile dans .page-wrapper (html et body en overflow hidden) ; on recale donc le conteneur qui défile réellement. */
/* 13/10/26 (Mathéo) : fiches produit, un seul menu dépliant ouvert à la fois (les autres se referment), sans saut de page. */
(function () {
  if (window.__amOneOpen || !/\/products\//.test(location.pathname)) return;
  window.__amOneOpen = 1;
  var SKIP = 'header, nav, dialog, [class*="drawer"], [class*="facet"], [class*="menu"]';
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open || !d.closest('main') || d.closest(SKIP)) return;
    var sc = window; for (var p = d.parentElement; p; p = p.parentElement) { var ov = getComputedStyle(p).overflowY; if ((ov === 'auto' || ov === 'scroll') && p.scrollHeight > p.clientHeight) { sc = p; break; } }
    var s = d.querySelector('summary'), y0 = s ? s.getBoundingClientRect().top : 0;
    document.querySelectorAll('main details[open]').forEach(function (o) {
      if (o !== d && !o.contains(d) && !d.contains(o) && !o.closest(SKIP)) o.open = false;
    });
    if (s) { var keep = function () { var dy = s.getBoundingClientRect().top - y0; if (Math.abs(dy) > 1) sc.scrollTo({ top: (sc === window ? window.scrollY : sc.scrollTop) + dy, behavior: 'instant' }); }; /* défilement doux du thème neutralisé ; le thème anime la fermeture : on recale pendant ~0,5 s */
      keep(); var t0 = Date.now(); (function loop() { keep(); if (Date.now() - t0 < 600) requestAnimationFrame(loop); })(); }
  }, true);
})();
/* am-one-open:end */
